module.exports = __webpack_public_path__ + "static/img/V2总成合力.d051fcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/controller/V2总成合力.jpg
// module id = Nfb/
// module chunks = 1